<!-- rota: /fatura/copertoplufatura  (name: fatura-copertoplufaturalistesi) -->
<template>
  <div id="app">
    <entegratorsecim ref="entegratorsecim" @callStop="EntegratorAyarlariKayitEdilmedi"  @callDevam="EntegratorAyarlariKayitEdildi" @callEntegratorVar="EntegratorVar"></entegratorsecim>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Coper-Self-invoice')}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <v-select :label="$t('Date-Type')" item-value="value" item-text="text" :items="itemstarihtip"
                          v-model="tarihTip"></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBasla" v-model="KayitTarihiBasla"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="KayitTarihiBitis" v-model="KayitTarihiBitis"></tarihcomp>
                      </v-flex>


                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getListcontrol()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>

                      <v-layout justify-end >
                        <v-flex xs12 md4 sm4>

                          <v-select 
        :items="paketSayilar"
        label="Paket Sayısı"
        v-model="paketSayi"
       
      ></v-select>                
                        </v-flex>
                                 
                         
                                     
                            </v-layout>
                    </v-layout>
                  </v-card>
                </v-flex>




                <v-flex xs12 pt-2 sm6 pr-2 md4>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project overdue">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> 
                            <span class="subheading black--text">
                              {{$t('Records')}} ({{dizaynData.length}})
                            </span>
                            </v-toolbar-title>
                          <v-spacer></v-spacer>
                            <v-flex xs12 sm4 md4 v-if="dizaynData.length!=0">
                               <v-layout justify-start>
                                 <v-btn flat @click="ItemAktarTumu(dizaynData,dizaynData2)" color="green">
                                 {{this.$t('Choose-All')}}
                                   <v-icon color="green">
                                     double_arrow
                                   </v-icon>
                                 </v-btn>                                     
                              </v-layout>

                             </v-flex>
                            
                        </v-toolbar>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-card color="grey lighten-5" flat>
                        <v-layout row wrap>
                          <v-flex pt-2 xs12 sm12 md12>
                            <v-card flat>
                              <v-layout  row wrap>
                          <v-flex v-if="dizaynData.length==0" xs12 md12>
                            <v-layout class="pa-3" row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('No-Records')}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>


                                <v-flex v-if="dizaynData.length!=0"  xs12 pt-2 pb-2 md12>

                                  <v-layout row wrap>


                                    <v-flex xs2 pl-1 sm1 md2>

                                      <v-layout justify-left>
                                        <div class="body-2 justify-center grey--text baslikSirala" @click="SolBasligaTikla('pnr')">PNR <v-icon v-if="solSiralamaSutunu=='pnr'" small color="grey">{{ solSiralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex xs3 sm2 md3>

                                      <v-layout justify-left>
                                        <div class="body-2 justify-center grey--text baslikSirala" @click="SolBasligaTikla('kayit')">{{ $t('Registration-Date') }} <v-icon v-if="solSiralamaSutunu=='kayit'" small color="grey">{{ solSiralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                      </v-layout>

                                    </v-flex>


                                    <v-flex xs3 sm2 md2>
                                      <v-layout justify-left>
                                        <div class="body-2 justify-center grey--text baslikSirala" @click="SolBasligaTikla('cari')">{{$t('Currentcode_label')}} <v-icon v-if="solSiralamaSutunu=='cari'" small color="grey">{{ solSiralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs2 sm2 md2>

                                      <v-layout justify-left>
                                        <div class="body-2 justify-center grey--text baslikSirala" @click="SolBasligaTikla('isim')">{{ $t('Name') }} <v-icon v-if="solSiralamaSutunu=='isim'" small color="grey">{{ solSiralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                      </v-layout>

                                    </v-flex>



                                    <v-flex xs2 sm2 md2>

                                      <v-layout justify-left>
                                        <div class="body-2 justify-center grey--text baslikSirala" @click="SolBasligaTikla('efatura')">{{ $t('E-Invoice') }} <v-icon v-if="solSiralamaSutunu=='efatura'" small color="grey">{{ solSiralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                      </v-layout>

                                    </v-flex>

                                    <v-flex xs12 sm1 md1>

                                      
                                      <v-layout justify-left>
                                        <div class="justify-center body-2  grey--text"></div>
                                      </v-layout>

                                    </v-flex>
 
                                  </v-layout>

                                </v-flex>
                              </v-layout>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-if="dizaynData.length!=0" xs12 md12>
                            <div class="scrollbar1" id="style-11">
                              <v-flex v-for="element in solSiraliKayitlar" :key="element.PNR_No" xs12 md12>

                                <v-layout align-center fill-height row wrap>


                                  <v-flex pl-1 xs2 sm1 md2>

                                    <v-layout justify-left>
                                      <div class="body-2 justify-center pnrBaglanti" @click="KaydiAc(element.PNR_No)" :title="$t('Reservation-Detail')">{{element.PNR_No}}</div>
                                    </v-layout>

                                  </v-flex>

                                  <v-flex xs2 sm2 md3>

                                    <v-layout justify-left>
                                      <div class="justify-center body-2 grey--text">
                                        {{element.Kayit_Tarihi | dateformat}}
                                      </div>
                                    </v-layout>
                                  </v-flex>


                                     <v-flex xs2 sm2 md2>

                                    <v-layout row full-width wrap justify-left>
                                      <div class="body-2 grey--text text-truncate">{{element.Cari_Kod}}</div>
                                    </v-layout>

                                  </v-flex>


                                <v-flex xs2 sm md3>

                                <v-layout justify-left>
                                  <div class="justify-center body-2 grey--text text-truncate">
                                    {{element.KisiIsim}}
                                  </div>
                                </v-layout>
                              </v-flex>

                               



                                  <v-flex xs2 sm2 md1>

                                    <v-layout justify-left>
                                      <div class="justify-center body-2  grey--text">{{element.EFatura}}</div>
                                    </v-layout>

                                  </v-flex>



                                  <v-flex xs2 sm1 md1>

                                    <v-layout justify-left>
                                      <v-btn icon ripple>
                                        <v-icon @click="ItemAktar(dizaynData,dizaynData2,element)" color="green">
                                          arrow_forward_ios
                                        </v-icon>
                                      </v-btn>
                                    </v-layout>

                                  </v-flex>
                                  <v-flex xs2 sm12 md12>
                                    <v-divider></v-divider>
                                  </v-flex>




                                </v-layout>

                              </v-flex>
                            </div>
                          </v-flex>


                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


                <v-flex xs12 pt-2 sm6 md8>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap class="pl-1 pr-1 project complete">
                        <v-toolbar flat="" size="120px" dark color="white">
                          <v-toolbar-title> <span class="subheading black--text">
                              {{$t('Records-Selected')}} ({{dizaynData2.length}})
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>

                          <!-- Siralama kendiliginden olusmuyor; kullanici bu
                               butona basana kadar liste eklenme sirasinda
                               duruyor ve Grup sutunu bos kaliyor. -->
                          <v-btn v-if="dizaynData2.length>0" flat
                            @click="SiralamayiHazirla()" color="green">
                            {{ $t('Sort-And-Group') }}
                            <v-icon color="green">sort</v-icon>
                          </v-btn>
                        </v-toolbar>
                      </v-layout>
                    </v-flex>


                    <v-flex pt-2 xs12 sm12 md12>
                      <v-card flat>
                        <v-layout row wrap class="pa-3 ">

                          <v-flex v-if="dizaynData2.length==0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text">{{$t('No-Records')}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>





                          <v-flex v-if="dizaynData2.length>0" xs12 md12>
                            <v-layout row wrap>
                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 	 justify-center   grey--text"></div>
                                </v-layout>

                              </v-flex>


                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('grup')">{{ $t('Group') }} <v-icon v-if="siralamaSutunu=='grup'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('pnr')">PNR <v-icon v-if="siralamaSutunu=='pnr'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('kayit')">{{ $t('Registration-Date') }} <v-icon v-if="siralamaSutunu=='kayit'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>

                              </v-flex>

                              <v-flex xs2 sm2 md2 pl-4>
                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('cari')">{{$t('Currentcode_label')}} <v-icon v-if="siralamaSutunu=='cari'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>
                              </v-flex>

                                 <v-flex xs2 sm1 md1>
                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('isim')">{{ $t('Name') }} <v-icon v-if="siralamaSutunu=='isim'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm1 md1 pr-4>
                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('fatura')">{{$t('Invoice-Date')}} <v-icon v-if="siralamaSutunu=='fatura'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>
                              </v-flex>

                              <v-flex xs2 sm2 md2 pl-4>
                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('vade')">{{$t('Maturity-Date')}} <v-icon v-if="siralamaSutunu=='vade'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>
                              </v-flex>


                              <v-flex xs12 sm2 md1>

                                <v-layout justify-left>
                                  <div class="body-2 justify-center grey--text baslikSirala" @click="BasligaTikla('efatura')">{{ $t('E-Invoice') }} <v-icon v-if="siralamaSutunu=='efatura'" small color="grey">{{ siralamaYonu==1 ? 'arrow_upward' : 'arrow_downward' }}</v-icon></div>
                                </v-layout>

                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 v-if="dizaynData.length>0" md12>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-for="satir in siraliKayitlar" :key="satir.element.kayit.PNR_No" xs12 md12>
                            <v-layout align-center fill-height row wrap>

                              <v-flex xs2 sm1 md1>

                                <v-layout justify-left>
                                  <v-btn icon ripple>
                                    <v-icon @click="ItemAktar2(dizaynData2,dizaynData,satir.element)" color="red">
                                      arrow_back_ios
                                    </v-icon>
                                  </v-btn>
                                </v-layout>

                              </v-flex>



                              <v-flex xs2 sm1 md1>

                                  <div class="body-2 justify-center grey--text">{{satir.grupNo}}</div>

                              </v-flex>
                              <v-flex xs2 sm1 md1>

                                  <div class="body-2 justify-center pnrBaglanti" @click="KaydiAc(satir.element.kayit.PNR_No)" :title="$t('Reservation-Detail')">{{satir.element.kayit.PNR_No}}</div>

                              </v-flex>

                              <v-flex xs2 sm2 md1>

                                  <div class="justify-center body-2 grey--text">
                                    {{satir.element.kayit.Kayit_Tarihi | dateformat}}
                                  </div>
                              </v-flex>

              

                              <v-flex xs2 sm2 md2 pl-4>

                                  <div class="body-2  grey--text text-truncate">{{satir.element.kayit.Cari_Kod}}</div>

                              </v-flex>

                              <v-flex xs2 sm1 md1>

                                  <div class="justify-center body-2 grey--text text-truncate">
                                    {{satir.element.kayit.KisiIsim}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md1 pr-4>
                                  <div class="justify-center body-2  grey--text">{{satir.element.FaturaTarihi | dateformat}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md2 pl-4>
                                  <div class="justify-center body-2  grey--text">{{satir.element.VadeTarihi | dateformat}}
                                  </div>
                              </v-flex>

                              <v-flex xs12 sm2 md1>
                                    <div class="justify-center body-2  grey--text">{{satir.element.kayit.EFatura}}</div>
                              </v-flex>

                              <v-flex xs12 sm2 md1>
                                <v-layout row wrap justify-left>

                                  <v-flex xs12 md12 sm12>
                                    <v-icon small @click="tarihDuzenle(satir.element)" color="green">edit</v-icon>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                              <v-flex xs2 sm12 md12>
                                <v-divider></v-divider>
                              </v-flex>




                            </v-layout>
                          </v-flex>
                          <v-flex xs12 v-if="dizaynData2.length>0" md12>
                            <v-btn flat @click="faturala()" color="green" block> {{ $t('Invoice-Selected-Records') }} </v-btn>

                          </v-flex>



                        </v-layout>

                      </v-card>


                    </v-flex>

                  </v-layout>



                </v-flex>


                <v-dialog persistent v-model="tarihdialog" max-width="400px">
                  <v-card>
                    <v-card-text>
                      <v-form ref="formtarih" lazy-validation>

                        <v-layout row wrap>

                          <v-flex pt-2 xs12 sm12 md12>
                            <tarihcomp :rules="[v => !!v || $t('Please-select-a-date')]"
                              :etiket="$t('Invoice-Date')" :detaygizle="false" v-bind:value="secilenKayityedek.FaturaTarihi"
                              v-model="secilenKayityedek.FaturaTarihi"></tarihcomp>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-checkbox hide-details v-model="vadeOtomatik"
                              :label="$t('Maturity-Date-Calculated-Automatically')"
                              @change="vadeOtomatikDegisti"></v-checkbox>
                          </v-flex>

                          <!-- tarihcomp'un "aktifmi" prop'u dogrudan :disabled'a
                               baglaniyor (bkz. customcomp/tarihim.vue), yani
                               true = PASIF. Otomatik hesap acikken alan pasif.
                               Zorunluluk kurali da kalkmali: bos ve pasif bir
                               alan zorunlu kalirsa formtarih.validate() surekli
                               false doner ve dialogdaki butonlarin hicbiri
                               calismaz. -->
                          <v-flex xs12 sm12 md12>
                            <tarihcomp
                              :rules="vadeOtomatik ? [] : [v => !!v || $t('Please-select-a-date')]"
                              :aktifmi="vadeOtomatik"
                              :etiket="$t('Maturity-Date')" :detaygizle="false" v-bind:value="secilenKayityedek.VadeTarihi"
                              v-model="secilenKayityedek.VadeTarihi"></tarihcomp>
                          </v-flex>
                          <v-flex pr-1 pl-1 xs12 sm12 md6>


                            <v-btn color="blue darken-1" outline block flat @click="tarihIptal()">{{$t("cancel_button")}}
                            </v-btn>

                          </v-flex>

                          <v-flex pr-1 pl-1 xs12 sm12 md6>


                            <v-btn color="blue darken-1" outline block flat @click="tarihOk()">{{ $t('OK') }}</v-btn>

                          </v-flex>

                          <v-flex pr-1 pl-1 xs12 sm12 md6>

                            <v-btn color="red" outline block flat @click="tarihOkTumu()">{{ $t('Apply-All') }} </v-btn>

                          </v-flex>



                        </v-layout>
                      </v-form>
                    </v-card-text>


                  </v-card>

                </v-dialog>








              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="500px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12>
                              <pnrbul v-model="RaporTopluParams.PNR_No" hide-details>
                              </pnrbul>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                           <cariaracomp v-bind:etiket="$t('Currentcode_label')" v-bind:value="RaporTopluParams.Cari_Kod.kod" v-model="RaporTopluParams.Cari_Kod.kod" :Coper="true"></cariaracomp>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemssaticitip" item-text="Aciklama" item-value="Kod"
                                v-model="RaporTopluParams.SaticiTip" :label="$t('Seller-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <genelarama :autofocuss="true" apiname="SaticiAra" :tip="RaporTopluParams.SaticiTip"
                                :label="$t('Seller-Code')" v-model="RaporTopluParams.SaticiKod"></genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-text-field hide-details v-model="RaporTopluParams.Acente" :label="$t('Agency')">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-text-field hide-details v-model="RaporTopluParams.KarsiRezKod"
                                :label="$t('Counter-Booking-Code')">
                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Expense-Center-v2')"
                                v-model="RaporTopluParams.MasrafMerkezi"></genelarama>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <genelarama apiname="MasrafMerkeziAra" :label="$t('Item-Expense-Centre')"
                                v-model="RaporTopluParams.KalemMasrafMerkezi"></genelarama>
                            </v-flex>
                            <v-flex xs12 sm12 md6>

                              <v-text-field hide-details v-model="RaporTopluParams.PozisyonNo" :label="$t('Position-No')">
                              </v-text-field>

                            </v-flex>
                            <v-flex xs12 sm12 md6>
                                <takipno v-model="RaporTopluParams.SatisGrubu" hide-details>
                              </takipno>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-select :items="itemsefaturami" item-text="text" item-value="value"
                                v-model="RaporTopluParams.EFatura" :label="$t('Invoice-Type')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox small v-model="RaporTopluParams.FaturalamayaHazir" :label="$t('Ready-for-Invoice')"
                                hide-details color="green">
                              </v-checkbox>


                            </v-flex>

                              <v-flex xs12 sm12 md12>
                              <v-checkbox small v-model="RaporTopluParams.SatisGrupTip" :label="$t('Visa-Sales')"
                                hide-details color="green">
                              </v-checkbox>
                            </v-flex>

                             <v-flex md12 xs12 sm12>
                              <v-select :items="itemsIcDis" item-text="text" item-value="value"
                                v-model="RaporTopluParams.Ic_Dis" :label="this.$t('Domestic-Abroad')" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <anatip clearable v-model="RaporTopluParams.AnaTip"></anatip>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../api/auth";
  import tarihcomp from "../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import tool from "../coper/tools";
  import rez from "../coper/rezervasyon";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import takipno from '../coper/component/takipno.vue';
  import entegratorsecim from "@/components/app/customcomp/entegratorsecim.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";


  export default {
    data() {
      return {
        paketSayi:300,
        paketSayilar: [100, 200, 300, 400,500,750,1000],
        secilenKayit: {},
        secilenKayityedek: 
        {
          FaturaTarihi : null, 
          VadeTarihi : null,
          pnrNo:null
        },
        tarihdialog: false,

        // Tarih duzenleme dialogunda vade uctan mi hesaplansin, elle mi
        // girilsin. Acikken vade PNR basina sunucudan aliniyor; elle girisin
        // anlami kalmadigi icin alan pasiflesip temizleniyor.
        vadeOtomatik: true,

        // Sag listedeki gruplama "Sirala ve Grupla" butonuna basilana kadar
        // uygulanmaz; grup numaralari da o ana kadar bos kalir.
        siralamaHazir: false,

        // Sag listede baslik tiklamasiyla secilen gosterim sirasi. null iken:
        // buton basilmissa kanonik sira (EFatura > Cari > Fatura > Vade),
        // basilmamissa eklenme sirasi. Yon: 1 artan, -1 azalan.
        siralamaSutunu: null,
        siralamaYonu: 1,

        // Sol liste kendi siralamasini tutar; iki listenin sirasi birbirinden
        // bagimsiz secilebiliyor. null iken uctan geldigi sira korunur.
        solSiralamaSutunu: null,
        solSiralamaYonu: 1,

        dizaynData2: [],
        dizaynData: [],
        itemssaticitip: rez.SaticiTip,

        itemsefaturami: [{
          text: this.$t('None'),
          value: null
        }, {
          text: 'E-Arşiv',
          value: 0
        }, {
          text: this.$t('E-Invoice'),
          value: 1
        }],

        itemsIcDis: [{
          text: this.$t('None'),
          value: null
        }, {
          text: 'Yurt İçi',
          value: 0
        }, {
          text: 'Yurt Disi',
          value: 1
        }],

        itemstarihtip: [{
          text: this.$t('Registration-Date'),
          value: 0
        }, {
          text: this.$t('Check-in-Date'),
          value: 1
        }, {
          text: this.$t('Check-out-Date'),
          value: 2
        }, {
          text: this.$t('Last-Leaving-Date'),
          value: 3
        }, {
          text: this.$t('First-Entry-Date'),
          value: 4
        }],

        tarihTip: 0,

        filtrevarmi: false,

        RaporTopluParams: {

          PNR_No: null,
          // Yalnizca .kod kullaniliyor. id/isim/isimAra alanlari vardi ama hicbir
          // zaman dolmuyordu: cariaracomp v-model olarak nesne degil SKALER emit ediyor.
          Cari_Kod: {
            kod: null,
          },
          Kayit_Tarihi1: null,
          Kayit_Tarihi2: null,
          Giris_Tarihi1: null,
          Giris_Tarihi2: null,
          Cikis_Tarihi1: null,
          Cikis_Tarihi2: null,
          SonCikis1: null,
          SonCikis2: null,
          IlkGiris1: null,
          IlkGiris2: null,
          FaturalamayaHazir: false,
          Acente: null,
          MasrafMerkezi: null,
          SatisGrubu: null,
          // Sablonda v-checkbox'a bagli ve getList icinde okunuyordu ama burada TANIMLI
          // DEGILDI; Vue 2'de data()'da olmayan bir ozellik v-model ile yazilinca reaktif
          // olmuyor ve filtreiptal de onu sifirlayamiyordu.
          SatisGrupTip: false,
          PozisyonNo: null,
          SaticiTip: 0,
          SaticiKod: null,
          KalemMasrafMerkezi: null,
          EFatura: null,
          KarsiRezKod: null,
          Ic_Dis:null,
          AnaTip: null,
        },

        KayitTarihiBasla: null,
        KayitTarihiBitis: null,
        doviztipi: [],
        load1: true,
        dialogfiltre: false,
        progress: false,
        tooltip: false,
        el: null,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    created() {
      if (this.$route.query.TakipNo) {
        this.RaporTopluParams.SatisGrubu = this.$route.query.TakipNo;
      }
      if (this.$route.query.RezervasyonTarihi) {
        this.KayitTarihiBasla = this.$route.query.RezervasyonTarihi;
        this.KayitTarihiBitis = this.$route.query.RezervasyonTarihi;
      }
    },
    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.el = this.$refs.fab.$el;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.SirketKodu
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        })
        .then(
          response => {
            this.doviztipi = response.body;
          },
          response => {
            // if/else'in iki dali birebir ayni sabit metni yaziyordu; status === 0
            // ayrimini zaten HataMesajiCoz kendi icinde yapiyor (baglanti yoksa i18n
            // mesaji, aksi halde sunucunun gercek aciklamasi).
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
          }
        );

        var secilifat = window.localStorage.getItem('container_secilifat');
        if(secilifat != null){
        this.dizaynData2 = JSON.parse(secilifat);
        window.localStorage.removeItem('container_secilifat');
        }

      if (this.$route.query.TakipNo || this.$route.query.RezervasyonTarihi) {
        this.$nextTick(() => {
          this.getList();
        });
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      genelarama,
      pnrbul,
      cariaracomp,
      takipno,
      entegratorsecim,
      anatip
    },

    methods: {




      
      getListcontrol()
    {
      this.$refs.entegratorsecim.control();
    },
    EntegratorAyarlariKayitEdildi() {
     
     this.$refs.entegratorsecim.close();

     this.getList();
   },
   EntegratorVar()
   {
    this.getList();
   },
 
   EntegratorAyarlariKayitEdilmedi() {
     alert("Entegrator Ayarları Kayıt Edilmedi");
     this.$refs.entegratorsecim.close();
   },
      tarihIptal() {
        this.tarihdialog = false
      },
      // Otomatik hesap acildiginda elle girilmis vade anlamini yitirir; alan
      // zaten pasiflesiyor, icerigi de temizlenir ki ekranda yanlis bir deger
      // durmasin. Kapatilirken temizlenmez: kullanici son gordugu tarihin
      // uzerinde calismaya devam edebilsin.
      vadeOtomatikDegisti(yeniDeger) {
        if (yeniDeger === true) {
          this.secilenKayityedek.VadeTarihi = null;
        }
      },

      // Dialogdaki tarihleri SECILI TEK satira uygular.
      tarihOk() {
        if (this.$refs.formtarih.validate() == false) {
          return;
        }

        this.secilenKayit.FaturaTarihi = this.secilenKayityedek.FaturaTarihi

        // Elle giris: girilen tarih oldugu gibi kullanilir, uca gidilmez.
        if (this.vadeOtomatik != true) {
          this.secilenKayit.VadeTarihi = this.secilenKayityedek.VadeTarihi
          this.tarihdialog = false
          return;
        }

        let params = {
          PNR_List: [this.secilenKayityedek.pnrNo],
          FaturaTarihi: this.secilenKayityedek.FaturaTarihi
        }

        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status != true) {
              this.text1 = (response.body.ErrorList || []).join(" ");
              this.snackbar = true;
              return;
            }

            // Uc, iptal edilmis PNR'yi hic dondurmedigi halde Status=true
            // diyor; eski kod bu durumda data[0].VadeTarihi deyip TypeError
            // firlatiyordu.
            var satir = (response.body.data || [])[0];
            if (satir) {
              this.secilenKayit.FaturaTarihi = satir.FaturaTarihi
              this.secilenKayit.VadeTarihi = satir.VadeTarihi
            }
          },
          response => {
            // Eskiden hata dali hic yoktu: istek basarisiz olunca dialog
            // kapanmis, vade eski kalmis ve kullanici hicbir sey gormemisti.
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
          }
        )

        this.tarihdialog = false
      },

      // Dialogdaki tarihleri listedeki TUM satirlara uygular.
      tarihOkTumu() {
        if (this.$refs.formtarih.validate() == false) {
          return;
        }

        // Elle giris: tek bir vade tarihi tum satirlara aynen yazilir.
        if (this.vadeOtomatik != true) {
          this.dizaynData2.forEach(element => {
            element.VadeTarihi = this.secilenKayityedek.VadeTarihi;
            element.FaturaTarihi = this.secilenKayityedek.FaturaTarihi;
          });

          this.tarihdialog = false
          return;
        }

        // Otomatik hesap: vade cari bazinda degisiyor
        // (CariHesapGenel.VadeGenGun), bu yuzden tum satirlara TEK bir vade
        // basmak yanlis. Uc PNR_List'i liste olarak alip her PNR icin ayri
        // vade dondurdugu icin bir istek yetiyor.
        var satirlar = this.dizaynData2;

        let params = {
          PNR_List: satirlar.map(element => element.kayit.PNR_No),
          FaturaTarihi: this.secilenKayityedek.FaturaTarihi
        }

        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            if (response.body.Status != true) {
              this.text1 = (response.body.ErrorList || []).join(" ");
              this.snackbar = true;
              return;
            }

            var vadeler = {};
            (response.body.data || []).forEach(satir => {
              vadeler[satir.PNR_No] = satir;
            });

            // Eslestirme SIRA ile degil PNR_No ile: uc IN(...) sorgusu
            // kullaniyor, donus sirasi garanti degil.
            var atlanan = 0;

            satirlar.forEach(element => {
              var vade = vadeler[element.kayit.PNR_No];

              // Fatura tarihi "tumune uygula" geregi her satira yazilir; vade
              // ise ancak uc o PNR icin bir sonuc dondurduyse degisir. Iptal
              // edilmis kayitlar sorgudan hic donmuyor, onlarin vadesine
              // dokunulmaz ve kullanici kac satirin atlandigini gorur.
              element.FaturaTarihi = this.secilenKayityedek.FaturaTarihi;

              if (vade) {
                element.VadeTarihi = vade.VadeTarihi;
              } else {
                atlanan += 1;
              }
            });

            if (atlanan > 0) {
              this.text1 = atlanan + " kaydın vade tarihi hesaplanamadı.";
              this.snackbar = true;
            }
          },
          response => {
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
          }
        );

        this.tarihdialog = false
      },

      tarihDuzenle(val) {
        this.secilenKayit = val

        this.secilenKayityedek.FaturaTarihi = val.FaturaTarihi
        // Otomatik hesap acikken alan pasif; icini eski vadeyle doldurmak
        // kullaniciya o degerin kullanilacagi izlenimini verirdi.
        this.secilenKayityedek.VadeTarihi = this.vadeOtomatik ? null : val.VadeTarihi
        this.secilenKayityedek.pnrNo=val.kayit.PNR_No

        this.tarihdialog = true

      },
      getDateNow() {
        return helpers.getDateNow();
      },
      faturala() {

        var degerler = []


        this.dizaynData2.forEach(element => {
          var kayit = {
            PNR_No: element.kayit.PNR_No,
            VadeTarihi: element.VadeTarihi,
            FaturaTarihi: element.FaturaTarihi,
           

          }
          degerler.push(kayit)
        });



        // Liste her acilista BENZERSIZ bir anahtara yazilip anahtar adrese
        // konuyor. Sabit anahtarla yazildiginda localStorage tum sekmelerde
        // ortak oldugu icin ikinci sekme birincinin listesini eziyor ve iki
        // sekme ayni faturalari gosteriyordu.
        var anahtar = tool.FaturaListesiYaz(degerler);

        // Yazilamadiysa (tarayici depolama kotasi dolu) sayfayi acmak
        // anlamsiz: acilan sekme listeyi bulamaz.
        if (!anahtar) {
          this.text1 = this.$t('Browser-Storage-Full')
          this.snackbar = true
          return
        }

        var url = '#/fatura/copertoplufaturaislem?liste=' + encodeURIComponent(anahtar)
        window.open(url, '_blank')
      },

      // Secilen paket kadar kaydi tek bir VadeTarihiHesapla istegiyle aktarir.
      //
      // Uc PNR_List'i List<long> olarak aliyor ve her PNR icin ayri bir satir
      // donuyor, yani N istek yerine TEK istek yetiyor. Eskiden dongu icinde
      // her element icin ayri istek atiliyordu ve govde de yanlisti:
      // "PNR_List: element.PNR_No" bir dizi degil ciplak sayi gonderiyordu
      // ({"PNR_List":111}). Uc bunu List<long>'a cozemedigi icin istek her
      // seferinde basarisiz oluyor, asagidaki geri donus dali de her satira
      // BUGUNUN tarihini yaziyordu. Sonuc: "Tumunu Sec" ile aktarilan hicbir
      // satirin vadesi hesaplanmiyordu (tek tek aktarmak ise dogru calisiyor).
      //
      // Burada fatura tarihi GONDERILMIYOR; uc her PNR icin kendi fatura
      // tarihini (otel ilk giris / son cikis / kayit tarihi, sirketin
      // FaturaTarihBasim parametresine gore) belirliyor. Bu yuzden tek istek
      // yeterli, tarihe gore gruplama gerekmiyor.
      ItemAktarTumu(kaynak, hedef) {
        var aktarilacak = kaynak.slice(0, this.paketSayi);

        if (aktarilacak.length === 0) {
          return;
        }

        let params = {
          PNR_List: aktarilacak.map(element => element.PNR_No)
        }

        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            var vadeler = {};

            if (response.body.Status == true) {
              (response.body.data || []).forEach(satir => {
                vadeler[satir.PNR_No] = satir;
              });
            } else {
              this.text1 = (response.body.ErrorList || []).join(" ");
              this.snackbar = true;
            }

            this.VadeleriSatirlaraDagit(aktarilacak, hedef, vadeler);
          },
          response => {
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
            this.VadeleriSatirlaraDagit(aktarilacak, hedef, {});
          }
        );

        kaynak.splice(0, this.paketSayi)
      },

      // Ucun dondugu vadeleri satirlara dagitir.
      //
      // Eslestirme SIRA ile degil PNR_No ile yapilir: uc IN(...) sorgusu
      // kullaniyor, donus sirasi garanti degil. Ayrica uc, listeden sonra
      // iptal edilmis / silinmis PNR'leri hic dondurmuyor (bkz.
      // TemelPNRBilgiSorgu filtreleri) ama yine de Status=true diyor; o
      // PNR'ler icin eski davranista oldugu gibi bugunun tarihine dusulur.
      VadeleriSatirlaraDagit(aktarilacak, hedef, vadeler) {
        aktarilacak.forEach(element => {
          var vade = vadeler[element.PNR_No];

          hedef.push({
            kayit: element,
            VadeTarihi: vade ? vade.VadeTarihi : this.getDateNow(),
            FaturaTarihi: vade ? vade.FaturaTarihi : this.getDateNow()
          });
        });
      },


      // Tek satiri aktarir. Istek zaten tek PNR icin gidiyor; ItemAktarTumu
      // ile ayni dagitim yardimcisini kullanarak "data[0]" varsayimindan
      // kurtulur. Uc bos liste dondugunde (iptal edilmis PNR) Status yine
      // true geliyor, eski kod bu durumda data[0].VadeTarihi diyip
      // TypeError firlatiyordu; satir da hicbir listeye eklenmiyordu.
      ItemAktar(kaynak, hedef, item) {

        var n = kaynak.indexOf(item);

        kaynak.splice(n, 1);

        let params = {
          PNR_List: [item.PNR_No]
        }
        tool.http_post(this, 'VadeTarihiHesapla', params).then(
          response => {
            var vadeler = {};

            if (response.body.Status == true) {
              (response.body.data || []).forEach(satir => {
                vadeler[satir.PNR_No] = satir;
              });
            } else {
              this.text1 = (response.body.ErrorList || []).join(" ");
              this.snackbar = true;
            }

            this.VadeleriSatirlaraDagit([item], hedef, vadeler);
          },
          response => {
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true;
            this.VadeleriSatirlaraDagit([item], hedef, {});
          }
        );
      },
      ItemAktar2(kaynak, hedef, item) {

        var n = kaynak.indexOf(item);

        kaynak.splice(n, 1);


        hedef.push(item.kayit);


      },
      // "Sirala ve Grupla" butonu. Siralama bir kere acildiktan sonra acik
      // kalir ve liste degistikce guncellenir; anlik bir kopya (snapshot)
      // alinmiyor, cunku ItemAktar2 ile satir geri gonderildiginde kopya o
      // satiri gostermeye devam ederdi.
      SiralamayiHazirla() {
        this.siralamaHazir = true;
      },

      // PNR'ye tiklaninca rezervasyon kaydini YENI SEKMEDE acar; boylece
      // hazirlanan liste ve elle duzenlenmis tarihler kaybolmaz.
      KaydiAc(pnrNo) {
        var url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + pnrNo;
        window.open(url, "_blank");
      },

      // Baslik tiklamasi: ayni sutuna tekrar basilirsa yon ters cevrilir,
      // farkli bir sutuna basilirsa o sutun artan sirayla secilir. Ucuncu
      // tiklamada siralama kaldirilmaz; kaldirmak icin ayri bir hareket yok,
      // cunku listenin her zaman belirli bir sirasi olmasi bekleniyor.
      BasligaTikla(sutun) {
        if (this.siralamaSutunu === sutun) {
          this.siralamaYonu = this.siralamaYonu * -1;
          return;
        }

        this.siralamaSutunu = sutun;
        this.siralamaYonu = 1;
      },

      // Bir sutunun karsilastirilabilir degeri. Tarihler yyyy-MM-dd'ye
      // indirgeniyor (bkz. GunAl); "grup" sutunu icin ayri bir deger yok,
      // onu KayitKarsilastir zaten kanonik sirayla veriyor.
      SutunDegeri(element, sutun) {
        if (sutun === "pnr") return element.kayit.PNR_No;
        if (sutun === "kayit") return this.GunAl(element.kayit.Kayit_Tarihi);
        if (sutun === "cari") return element.kayit.Cari_Kod;
        if (sutun === "isim") return element.kayit.KisiIsim;
        if (sutun === "fatura") return this.GunAl(element.FaturaTarihi);
        if (sutun === "vade") return this.GunAl(element.VadeTarihi);
        if (sutun === "efatura") return element.kayit.EFatura;
        return null;
      },

      // Iki degeri tipine gore kiyaslar: sayilar sayisal, metinler Turkce
      // siralamayla. null'lar sona atilmaz, bos deger sayilir ki sira her
      // zaman kararli olsun.
      DegerKarsilastir(x, y) {
        if (typeof x === "number" || typeof y === "number") {
          return (x || 0) - (y || 0);
        }
        return String(x || "").localeCompare(String(y || ""), "tr");
      },

      // Sag listede secili sutuna gore karsilastirma.
      SutunKarsilastir(a, b) {
        if (this.siralamaSutunu === "grup") {
          return this.KayitKarsilastir(a, b) * this.siralamaYonu;
        }

        var fark = this.DegerKarsilastir(
          this.SutunDegeri(a, this.siralamaSutunu),
          this.SutunDegeri(b, this.siralamaSutunu)
        );

        return fark * this.siralamaYonu;
      },

      // Sol listenin satirlari uctan geldigi ham haliyle duruyor (sag listede
      // oldugu gibi {kayit, FaturaTarihi, VadeTarihi} sarmalayicisi yok), bu
      // yuzden alanlara dogrudan erisilir.
      SolSutunDegeri(element, sutun) {
        if (sutun === "pnr") return element.PNR_No;
        if (sutun === "kayit") return this.GunAl(element.Kayit_Tarihi);
        if (sutun === "cari") return element.Cari_Kod;
        if (sutun === "isim") return element.KisiIsim;
        if (sutun === "efatura") return element.EFatura;
        return null;
      },

      SolSutunKarsilastir(a, b) {
        var fark = this.DegerKarsilastir(
          this.SolSutunDegeri(a, this.solSiralamaSutunu),
          this.SolSutunDegeri(b, this.solSiralamaSutunu)
        );

        return fark * this.solSiralamaYonu;
      },

      // Sol liste basligi. Sag listedeki BasligaTikla ile ayni davranis:
      // ayni sutuna tekrar basmak yonu ters cevirir, farkli sutun artanla
      // baslar.
      SolBasligaTikla(sutun) {
        if (this.solSiralamaSutunu === sutun) {
          this.solSiralamaYonu = this.solSiralamaYonu * -1;
          return;
        }

        this.solSiralamaSutunu = sutun;
        this.solSiralamaYonu = 1;
      },

      // Tarih alanlari iki ayri bicimde geliyor: uc "2026-09-19T00:00:00",
      // helpers.getDateNow() ise "2026-09-19" donduruyor. Ilk 10 karakter
      // alinmazsa AYNI gun iki farkli grup sayilir ve siralama da bozulur.
      GunAl(tarih) {
        if (tarih == null) {
          return "";
        }
        return String(tarih).substring(0, 10);
      },

      // Grup numarasinin dayandigi dortlu. Ayni anahtara sahip satirlar ayni
      // numarayi paylasir.
      GrupAnahtari(element) {
        return [
          element.kayit.EFatura,
          element.kayit.Cari_Kod,
          this.GunAl(element.FaturaTarihi),
          this.GunAl(element.VadeTarihi)
        ].join("|");
      },

      // Siralama olcutu: EFatura > Cari Kod > Fatura Tarihi > Vade Tarihi.
      // EFatura sayisal (0/1); Cari Kod metin oldugu icin Turkce siralama
      // kullanilir; tarihler yyyy-MM-dd'ye indirgendigi icin duz metin
      // karsilastirmasi dogru tarih sirasini verir.
      KayitKarsilastir(a, b) {
        var fark = (a.kayit.EFatura || 0) - (b.kayit.EFatura || 0);
        if (fark !== 0) {
          return fark;
        }

        fark = String(a.kayit.Cari_Kod || "").localeCompare(String(b.kayit.Cari_Kod || ""), "tr");
        if (fark !== 0) {
          return fark;
        }

        fark = this.GunAl(a.FaturaTarihi).localeCompare(this.GunAl(b.FaturaTarihi));
        if (fark !== 0) {
          return fark;
        }

        return this.GunAl(a.VadeTarihi).localeCompare(this.GunAl(b.VadeTarihi));
      },

      getList: getList,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },

    computed: {
      // Sag taraftaki listenin gosterim kaynagi. Iki bagimsiz is yapiyor:
      //
      //  1) GRUP NUMARASI - yalnizca "Sirala ve Grupla" butonuna basildiysa.
      //     Numaralar HER ZAMAN kanonik sirada (EFatura > Cari Kod > Fatura
      //     Tarihi > Vade Tarihi) uretilir ve satira yapisir. Boylece
      //     kullanici baslikla baska bir siraya gecse bile bir satirin grup
      //     numarasi degismez; numara satirin kimligi, gorunum sirasi degil.
      //
      //  2) GOSTERIM SIRASI - baslik tiklandiysa o sutuna gore, tiklanmadiysa
      //     kanonik sira (buton basiliysa) ya da eklenme sirasi.
      //
      // dizaynData2 KOPYALANIR (slice): sort diziyi yerinde degistiriyor,
      // dogrudan uygulanirsa Vue'nun izledigi diziyi degistirip her yeniden
      // hesaplamada tetiklenme dongusune yol acabilirdi. Satir NESNELERI ayni
      // referans kaldigi icin ItemAktar2'nin indexOf'u ve tarihDuzenle'nin
      // dogrudan yazmasi calismaya devam ediyor.
      //
      // Karsilastiricilar ok fonksiyonuyla sarmalaniyor: sort, geri cagrimi
      // this'siz cagiriyor; dogrudan this.KayitKarsilastir gecilseydi
      // icerideki this.GunAl yalnizca Vue'nun metotlari otomatik baglamasi
      // sayesinde calisirdi, testte cagrildiginda patlardi.
      siraliKayitlar() {
        var kanonik = null;
        var numaralar = {};

        if (this.siralamaHazir == true) {
          kanonik = this.dizaynData2.slice().sort((a, b) => this.KayitKarsilastir(a, b));

          var grupNo = 0;
          var oncekiAnahtar = null;

          kanonik.forEach(element => {
            var anahtar = this.GrupAnahtari(element);

            if (anahtar !== oncekiAnahtar) {
              grupNo += 1;
              oncekiAnahtar = anahtar;
            }

            numaralar[element.kayit.PNR_No] = grupNo;
          });
        }

        var gosterilecek;

        if (this.siralamaSutunu != null) {
          gosterilecek = this.dizaynData2.slice().sort((a, b) => this.SutunKarsilastir(a, b));
        } else if (kanonik != null) {
          gosterilecek = kanonik;
        } else {
          gosterilecek = this.dizaynData2;
        }

        return gosterilecek.map(element => {
          return {
            element: element,
            grupNo: this.siralamaHazir == true ? numaralar[element.kayit.PNR_No] : null
          };
        });
      },

      // Sol listenin gosterim kaynagi. Sag listeden farkli olarak gruplama
      // yok; yalnizca baslik tiklamasiyla secilen sira uygulanir, secim
      // yapilmadiysa uctan geldigi sira korunur.
      //
      // slice ile kopyalaniyor: sort diziyi yerinde degistiriyor ve dizaynData
      // Vue tarafindan izleniyor. Satir NESNELERI ayni referans kaldigi icin
      // ItemAktar'in indexOf'u calismaya devam ediyor.
      solSiraliKayitlar() {
        if (this.solSiralamaSutunu == null) {
          return this.dizaynData;
        }

        return this.dizaynData.slice().sort((a, b) => this.SolSutunKarsilastir(a, b));
      }
    },
  };

  function filtrele() {
    this.dialogfiltre = true;
  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;

    this.RaporTopluParams.PNR_No = null
    // Burada eskiden "RaporTopluParams.CariKod = null" yaziyordu. Boyle bir alan yok:
    // gercek ad Cari_Kod ve bir nesne. Atama, Vue'nun izlemedigi yepyeni bir ozellik
    // yaratip null yaziyordu; secili cari HIC temizlenmiyor, Iptal'den sonra da filtre
    // olarak gitmeye devam ediyordu.
    this.RaporTopluParams.Cari_Kod.kod = null
    this.RaporTopluParams.FaturalamayaHazir = false
    this.RaporTopluParams.Acente = null
    this.RaporTopluParams.MasrafMerkezi = null
    this.RaporTopluParams.SatisGrubu = null
    this.RaporTopluParams.SatisGrupTip = false
    this.RaporTopluParams.PozisyonNo = null
    this.RaporTopluParams.SaticiTip = null
    this.RaporTopluParams.SaticiKod = null
    this.RaporTopluParams.KalemMasrafMerkezi = null
    this.RaporTopluParams.EFatura = null
    this.RaporTopluParams.KarsiRezKod = null
    this.RaporTopluParams.Ic_Dis = null
    this.RaporTopluParams.AnaTip = null
    

  }

  function getList() {
    if (this.$refs.formgunluksatis.validate()) {

      this.dizaynData2 = [];
      this.dizaynData = [];

      var bastarih = new Date(this.KayitTarihiBasla);
      var bittarih = new Date(this.KayitTarihiBitis);

      if (this.tarihTip == 0) {

        this.RaporTopluParams.Kayit_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Kayit_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null


      } else if (this.tarihTip == 1) {


        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Giris_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null


      } else if (this.tarihTip == 2) {


        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = this.KayitTarihiBasla
        this.RaporTopluParams.Cikis_Tarihi2 = this.KayitTarihiBitis

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null

      } else if (this.tarihTip == 3) {

        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = this.KayitTarihiBasla
        this.RaporTopluParams.SonCikis2 = this.KayitTarihiBitis

        this.RaporTopluParams.IlkGiris1 = null
        this.RaporTopluParams.IlkGiris2 = null

      } else if (this.tarihTip == 4) {

        this.RaporTopluParams.Kayit_Tarihi1 = null
        this.RaporTopluParams.Kayit_Tarihi2 = null

        this.RaporTopluParams.Giris_Tarihi1 = null
        this.RaporTopluParams.Giris_Tarihi2 = null

        this.RaporTopluParams.Cikis_Tarihi1 = null
        this.RaporTopluParams.Cikis_Tarihi2 = null

        this.RaporTopluParams.SonCikis1 = null
        this.RaporTopluParams.SonCikis2 = null

        this.RaporTopluParams.IlkGiris1 = this.KayitTarihiBasla
        this.RaporTopluParams.IlkGiris2 = this.KayitTarihiBitis

      }


      if (bastarih <= bittarih) {

        this.progress = true;
        this.load1 = false;


        var RaporParam = {}

        RaporParam.PNR_No = this.RaporTopluParams.PNR_No


        RaporParam.Kayit_Tarihi1 = this.RaporTopluParams.Kayit_Tarihi1
        RaporParam.Kayit_Tarihi2 = this.RaporTopluParams.Kayit_Tarihi2
        RaporParam.Giris_Tarihi1 = this.RaporTopluParams.Giris_Tarihi1
        RaporParam.Giris_Tarihi2 = this.RaporTopluParams.Giris_Tarihi2
        RaporParam.Cikis_Tarihi1 = this.RaporTopluParams.Cikis_Tarihi1
        RaporParam.Cikis_Tarihi2 = this.RaporTopluParams.Cikis_Tarihi2
        RaporParam.SonCikis1 = this.RaporTopluParams.SonCikis1
        RaporParam.SonCikis2 = this.RaporTopluParams.SonCikis2
        RaporParam.IlkGiris1 = this.RaporTopluParams.IlkGiris1
        RaporParam.IlkGiris2 = this.RaporTopluParams.IlkGiris2
        RaporParam.KarsiRezKod = this.RaporTopluParams.KarsiRezKod
        
        


        if (this.RaporTopluParams.Cari_Kod != null) {

          if (this.RaporTopluParams.Cari_Kod.kod != null) {
            RaporParam.Cari_Kod = this.RaporTopluParams.Cari_Kod.kod
          } else {
            RaporParam.Cari_Kod = null
          }
        } else {
          RaporParam.Cari_Kod = null
        }

        RaporParam.SaticiTip = this.RaporTopluParams.SaticiTip


        if (this.RaporTopluParams.SaticiKod != null) {
          RaporParam.SaticiKod = this.RaporTopluParams.SaticiKod.kod
        } else {
          RaporParam.SaticiKod = this.RaporTopluParams.SaticiKod
        }


        if (this.RaporTopluParams.KalemMasrafMerkezi != null) {
          RaporParam.KalemMasrafMerkezi = this.RaporTopluParams.KalemMasrafMerkezi.kod
        } else {
          RaporParam.KalemMasrafMerkezi = null
        }


        if (this.RaporTopluParams.MasrafMerkezi != null) {
          RaporParam.MasrafMerkezi = this.RaporTopluParams.MasrafMerkezi.kod
        } else {
          RaporParam.MasrafMerkezi = null
        }
        RaporParam.FaturalamayaHazir = this.RaporTopluParams.FaturalamayaHazir
        RaporParam.Acente = this.RaporTopluParams.Acente
        RaporParam.SatisGrubu = this.RaporTopluParams.SatisGrubu
        RaporParam.PozisyonNo = this.RaporTopluParams.PozisyonNo
        RaporParam.EFatura = this.RaporTopluParams.EFatura
        RaporParam.Ic_Dis = this.RaporTopluParams.Ic_Dis
        RaporParam.AnaTip = this.RaporTopluParams.AnaTip
        
        if(this.RaporTopluParams.SatisGrupTip==true)
        {
          RaporParam.SatisGrupTip=1;
        }
        
        var params = {
          Value: RaporParam
        }

        // Bayraklar ISTEK BITINCE geri alinir. Eskiden tam burada, yani istek daha
        // atilmadan once geri aliniyorlardi; aradaki her sey senkron oldugu ve Vue
        // render'i nextTick'e ertelendigi icin spinner (v-if="progress") hic
        // gorunmuyor, buton (v-if="load1") hic gizlenmiyordu. tool.http_post bu
        // bayraklara dokunmuyor, o yuzden her iki dalda da elle geri alinmali.
        // http_post SENKRON da patlayabiliyor: tools.js icinde localStorage'daki
        // credentials okunup alanlari .toString()'leniyor, credentials yoksa istisna
        // daha promise olusmadan firliyor. O durumda asagidaki iki dal HIC calismaz,
        // yani bayraklar acik kalir: spinner sonsuza kadar doner ve arama butonu
        // (v-if="load1") kayboldugu icin kullanici sayfayi yenilemeden tekrar deneyemez.
        var istek;
        try {
          istek = tool.http_post(this, 'KesilecekSatisFaturasiList', params);
        } catch (hata) {
          this.progress = false;
          this.load1 = true;
          this.text1 = hata.message;
          this.snackbar = true;
          return;
        }

        istek.then(
          response => {
            this.progress = false;
            this.load1 = true;

            if (response.body.Status == true) {
              this.dizaynData = response.body.data

              // Eski SABIT anahtarin temizligi. Artik her acilista benzersiz
              // anahtar yaziliyor (bkz. faturala); bu satir yalnizca bu
              // degisiklikten once kalmis bir listenin, adreste ?liste
              // olmadan acilan bir sekmede yeniden okunmasini engelliyor.
              window.localStorage.removeItem('container_toplufatura')

            } else {
              // ErrorList[0] degil TAMAMI: sunucu birden fazla dogrulama hatasi
              // dondurebiliyor ve yalnizca ilkini gostermek digerlerini gizliyordu.
              // Ayrica ErrorList null geldiginde [0] okumak TypeError atiyor, bu da
              // basarili dalin icinde oldugu icin asagidaki hata callback'ine
              // DUSMUYOR: snackbar hic acilmiyordu.
              this.text1 = (response.body.ErrorList || []).join(" ");
              this.snackbar = true
            }
          },
          response => {
            this.progress = false;
            this.load1 = true;

            // Sabit metin yerine sunucunun gercek aciklamasi. ArkmanNext is kurali
            // hatalarini duz metin govdeyle donduruyor; "Hata Olustu, tekrar deneyiniz"
            // yazmak o aciklamayi tamamen kaybediyordu.
            this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
            this.snackbar = true
          }
        );
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true;
      }
    }
  }
</script>
<style >


  /* Sag listedeki tiklanabilir sutun basliklari. */
  .baslikSirala {
    cursor: pointer;
    user-select: none;

    /* Baslik, display:flex olan bir v-layout'un icinde duruyor. min-width:0
       olmadan flex ogesi icerigi kadar genis kalmakta direnir ve sutun
       kutusunu tasirir; sag listenin gridi 12 birimin tamamini kullandigi
       icin bir tasma son sutunlari (E-Fatura, duzenle) alt satira atiyor. */
    display: flex;
    align-items: center;
    min-width: 0;
    line-height: 1.2;
    overflow-wrap: anywhere;
  }

  /* Ok simgesi metni sikistirmasin ama kendisi de tasmasin. */
  .baslikSirala .v-icon {
    flex: 0 0 auto;
    margin-left: 2px;
  }

  .baslikSirala:hover {
    text-decoration: underline;
  }

  /* PNR degeri: tiklaninca rezervasyon kaydi yeni sekmede acilir. Baglanti
     oldugu belli olsun diye gri yerine mavi. */
  .pnrBaglanti {
    cursor: pointer;
    color: #1976d2;
  }

  .pnrBaglanti:hover {
    text-decoration: underline;
  }

  .project.complete {
    border-left: 4px solid green;
  }

  .project.overdue {
    border-left: 4px solid red;
  }

  .scrollbar1 {
width: 100%;
  height:700px;
  background-color:white;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: rebeccapurple green;
  scrollbar-width: auto;
  }

  /*
 *  STYLE 1
 */

  #style-11::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-11::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-11::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, .3);

  }
</style>